/**
 * Componente WhoWeAreSection
 * Sección "Quiénes somos" con información del equipo
 */
import React, { memo } from "react";
import { motion } from "framer-motion";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ComicButton from "../../shared/components/ComicButton/ComicButton";

const WhoWeAreSection = () => {
    const navigate = useNavigate();

    return (
        <motion.div
            key="quienes-somos"
            className="absolute inset-0 flex flex-col items-center justify-center text-center bg-black bg-opacity-90"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
        >
            <div className="flex flex-col items-center justify-center px-4 w-full h-full max-w-4xl overflow-hidden">
                <h1 className="text-yellow-500 font-bold mb-4" style={{ fontSize: "clamp(1.5rem, 3vw, 2.5rem)" }}>
                    <Trans i18nKey="whoweareTitle" />
                </h1>
                <div
                    className="text-white text-center leading-relaxed"
                    style={{ fontSize: "clamp(0.8rem, 2vw, 1.2rem)", maxHeight: "60%", overflowY: "auto" }}
                >
                    <p className="mb-4">
                        <Trans i18nKey="whoweareText0" />
                    </p>
                    <p className="mb-4">
                        <Trans i18nKey="whoweareText1" />
                    </p>
                    <p className="mb-4">
                        <Trans i18nKey="whoweareText2" />
                    </p>
                    <p className="italic">
                        <Trans i18nKey="whoweareText3" />
                    </p>
                </div>
                <div className="mt-4 text-white">
                    <h2 className="font-bold mb-2 text-yellow-500" style={{ fontSize: "clamp(1rem, 2.5vw, 1.5rem)" }}>
                        <Trans i18nKey="whoweareAuthors" />
                    </h2>
                    <ul className="list-disc list-inside text-center" style={{ fontSize: "clamp(0.8rem, 2vw, 1rem)" }}>
                        <li>Gustavo Arcones</li>
                        <li>Santiago Bellido</li>
                        <li>Fco. José García</li>
                        <li>Matías López</li>
                        <li>Antonio Vicente</li>
                        <li>Carlos Ortega</li>
                    </ul>
                </div>
                <div className="mt-6">
                    <ComicButton
                        buttonName={<Trans i18nKey="backToMenu" />}
                        hoverBtnName={<Trans i18nKey="backToMenu" />}
                        handleButtonClick={() => navigate(-1)}
                    />
                </div>
            </div>
        </motion.div>
    );
};

export default memo(WhoWeAreSection);
